import { siteMap } from "internal-sitemap";
import RecentItemsList from "molecules/lists/recent-items-list";
import RecentBookmarkListItem from "molecules/recent-items-list-items/recent-bookmark-list-item";
import RecentNotebooksListItem from "molecules/recent-notebooks-list-item.tsx/recent-notebooks-list-item";
import useDashboardNotebooks from "pages/notebooks/use-dashboard-notebooks";
import React from "react";
import { useHistory } from "react-router";
import useNetworkInformation from "utilities/contexts/network-information/use-network-information";
import useDashboardBookmarks from "utilities/hooks/domain/user-bookmarks/use-dashboard-bookmarks";
import useCultureCodeRoute from "utilities/hooks/routing/use-culture-code-route";
import { t } from "utilities/localization-utils";

const CSS_BASE_CLASS = "c-dashboard-recent-items";

const DashboardRecentItems = () => {
    const { push } = useHistory();
    const { generateCultureCodedRoute } = useCultureCodeRoute();
    const { isOnline } = useNetworkInformation();

    // Bookmarks
    const { bookmarks } = useDashboardBookmarks();
    const handleBookmarkViewAllClick = () => {
        push(generateCultureCodedRoute(siteMap.myLink.myBookmarks.dashboard));
    };

    //Notebooks
    const { notebooks } = useDashboardNotebooks();
    const handleNotebooksViewAllClick = () => {
        push(generateCultureCodedRoute(siteMap.notebooks.list));
    };

    return (
        <section
            className={
                isOnline ? `${CSS_BASE_CLASS}` : `${CSS_BASE_CLASS} -offline`
            }>
            <RecentItemsList
                resource={t("bookmark_plural")}
                onViewAllClick={handleBookmarkViewAllClick}>
                {bookmarks.map((bookmark) => (
                    <RecentBookmarkListItem
                        bookmark={bookmark}
                        key={bookmark.id}
                    />
                ))}
            </RecentItemsList>
            <RecentItemsList
                resource={t("notebooks")}
                onViewAllClick={handleNotebooksViewAllClick}>
                {notebooks.map((notebook) => (
                    <RecentNotebooksListItem
                        notebook={notebook}
                        key={notebook.id}
                    />
                ))}
            </RecentItemsList>
        </section>
    );
};

export default DashboardRecentItems;
